import { getMoment, createPageSelector } from '../../util';
import { get, find, isEmpty, map, last } from 'lodash';
import { createSelector } from 'reselect';

export const getPageInfo = createPageSelector('lessons');

export const getLessons = createSelector(
  state => state.lessons.main.data.list,
  lessons => {
    // put sorting functions and stuff here
    if (isEmpty(lessons)) return [];
    return map(lessons, l => {
      const { _id, group, course, location, current, status, price, timeline, creditsUsed } = l;
      const {
        tutor: { user: { first: tf, last: tl } },
        studentMembers: [{ student: { user: { first: sf, last: sl } } }],
      } = group;
      let subject = 'Course '; let number = 'Not Available';
      // let university = { name: 'University Not Available' };
      if (course) ({ subject, number } = course);
      const time = getMoment(current.startTime.timestamp);
      return {
        tutor: `${tf} ${tl}`,
        student: `${sf} ${sl}`,
        studentId: group.studentMembers[0].student._id,
        studentUniversity: course.university.name,
        course: `${subject} ${number}`,
        duration: current.timeslots.length / 2,
        'credits used': (creditsUsed / 100).toFixed(2),
        // university: university.name,
        status,
        location: (location || { name: 'Not Available' }).name,
        created: getMoment((timeline || [{ date: { timestamp: '0' } }])[0].date.timestamp).format('MMM D, Y'),
        time: time.format('MMM D, Y'),
        price: (price / 100).toFixed(2),
        _id,
      };
    });
  }
);



// WEBPACK FOOTER //
// ./src/modules/credited_history/selector.js